import Head from 'next/head';
import { FC } from 'react';

import { JsonLdScriptProps } from './types';

const JsonLdScript: FC<JsonLdScriptProps> = ({ data }) => {
    if (!data) {
        return null;
    }

    return (
        <Head>
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />
        </Head>
    );
};

export default JsonLdScript;
